// const filter = require("./filter/filter");
import "jquery";
import "bootstrap";
import "selectric";
import "./redactor/redactor.min.js";
import "./redactor/fullscreen.min.js";
const importer = require("./importer/importer");
global.$ = global.jQuery = require('jquery');

global.Choices = require ("choices.js");
import { upgrades } from './products/upgrades.js';
require("bootstrap-datepicker");
require("./redactor/nl");
require("./redactor/config");
require("moment");
require("chart.js/dist/Chart.bundle.min");

$(() => {
  // Set content top margin depending on header height
  $(window).on("load resize", () => {
    const headerSize =
      $(".page__header").height() + $("#subheader").height() + 9;
    $(".container-fluid").css("margin-top", headerSize);
  });

  // ---- Textarea WYSIWYG ---- //
  $R(".wysiwyg", {
    lang: "nl",
    buttonsAddBefore: {
      before: "format",
      buttons: ["undo", "redo"]
    },
    linkTarget: "_blank",
    toolbarFixedTopOffset: 120
  });
  $R(".wysiwyg-img", {
    lang: "nl",
    imageUpload: "/image-upload",
    buttonsAddBefore: {
      before: "format",
      buttons: ["undo", "redo"]
    },
    linkTarget: "_blank",
    toolbarFixedTopOffset: 120
  });


  // ---- Alerts ---- //
  const alert = $(".alert.alert-success.show");
  alert.fadeTo(2000, 500).slideUp(500, () => alert.slideUp(500));

  // ---- Modals ---- //
  const modalButton = $('button.btn-price[data-toggle="modal"]');

  modalButton.tooltip();

  modalButton.on("click", e => {
    // get data attributes
    let { id, xAxis, xAxisName, yAxis, yAxisName } = e.currentTarget.dataset;

    $("#xAxis").text(xAxis);
    $("#xAxisName").text(xAxisName);
    $("#yAxis").text(yAxis);
    $("#yAxisName").text(yAxisName);
    const url = `pricetable/${id}`;
    // fill in product data in inputs
    $.ajax({
      url: url,
      method: "get"
    }).done(response => setValues(response, id));
  });

  // ---- Submit Form ---- //
  $("body").on("click", "[data-submit]", e => {
    e.preventDefault();
    const form_id = e.currentTarget.dataset.submit;
    $(form_id).submit();
  });

  $("[data-link]").on(
    "click",
    e => (location.href = e.currentTarget.dataset.link)
  );

  $("#imageUpload").on("change", e => readURL(e.currentTarget));

  $(".radio.hide").on("click", e => {
    const { id } = e.currentTarget.dataset;
    hideColorList(id);
  });

  $(".radio.show").on("click", e => {
    const { id } = e.currentTarget.dataset;
    showColorList(id);
  });

  const csvField = $("#csv-field");
  $("#csv-import-trigger").on("click", () => csvField.slideToggle(300));
  if (csvField.hasClass("has-error")) csvField.show();

  // ---- Select all modal ---- //
  $(".select-all").on("click", e => {
    let id = e.currentTarget.dataset.upgradeId;
    const checkbox = $(`[data-upgrade-id="${id}"]:checkbox`);
    if (e.currentTarget.checked)
      checkbox.each((index, element) => (element.checked = "checked"));
    else checkbox.each((index, element) => (element.checked = ""));
  });

  // --- Select all index tables --- //
  $("#select-all").on("click", e => {
    const checkbox = $(":checkbox");
    if (e.currentTarget.checked)
      checkbox.each((index, element) => (element.checked = "checked"));
    else checkbox.each((index, element) => (element.checked = ""));
  });

  $(":checkbox").on("click", () => $("button.delete-button").show());

  $(".nav-link.disabled").tooltip();

  $(".navbar-toggler, .dim").on("click", e => {
    $(".page__navigation").toggleClass("show");
    $(".dim").toggleClass("show");
  });

  // Datepicker
  $(".input-daterange input").each(function() {
    $(this).datepicker({
      format: "dd-mm-yyyy",
      todayHighlight: true,
      assumeNearbyYear: true,
      endDate: "0d"
    });
  });

  // --- Hide and show on product documents --- //
  $(".documents-list .toggle-input, .cancel-toggle-input").on("click", e => {
    let document_id = e.currentTarget.dataset.documentId;
    $(`#input${document_id}`).toggleClass("hidden");
    $(`#cancelToggleInput${document_id}`).toggleClass("hidden");
    $(`#document-link${document_id}`).toggleClass("hidden");
    $(`#toggleInput${document_id}`).toggleClass("hidden");
  });

  $(".remove-document, .cancel-remove-document").on("click", e => {
    let document_id = e.currentTarget.dataset.documentId;
    let checkbox = $(`#removeDocumentCheck${document_id}`);
    $(`#document-link${document_id}`).toggleClass("marked");
    $(`#removeDocument${document_id}`).toggleClass("hidden");
    $(`#cancelRemoveDocument${document_id}`).toggleClass("hidden");
    checkbox.prop("checked", !checkbox[0].checked);

    $(".delete-notification").show();
  });

  // $('.cancel-remove-document').on('click', e => {
  //     let document_id = e.currentTarget.dataset.documentId;
  //     $(`#document-link${document_id}`).css({
  //         'text-decoration': 'none',
  //         'color': '#3C7AC5',
  //         'font-style': 'normal'
  //     });
  //     $(`#removeDocument${document_id}`).show();
  //     $(`#toggleInput${document_id}`).show();
  //     $(`#cancelRemoveDocument${document_id}`).show();
  //     $(e.currentTarget).hide();
  //     $(`#removeDocumentCheck${document_id}`).prop('checked', false);
  // });

  $("#documents").on("change", e => {
    let files = e.currentTarget.files;
    $(".selected-files").empty();
    for (let i = 0; i < files.length; ++i) {
      $(".selected-files").append(`<li> ${files.item(i).name} </li>`);
    }
  });

  $("input[data-slug]").on("change", function(e) {
    let val = $(this).val();
    val = val.trim().replace(/[^A-Za-z0-9-\/]+/g, "-");
    $(this).val(val);
  });
});

// ---- Selectric ---- //
const select = $(
  "select" + ":not(.phpdebugbar-datasets-switcher)" + ":not(#active)" + ":not(.choices)" + ":not(.vanilla)"
);

select.selectric({
  multiple: {
    separator: ", ", // Type: String.             Description: Items separator.
    keepMenuOpen: true, // Type: Boolean.            Description: Close after an item is selected.
    maxLabelEntries: false // Type: Boolean or Integer. Description: Max selected items do show.
  }
});

// ---- Filter ---- //
// filter.set();
importer.set();

// ---- Upload Image ---- //
const readURL = input => {
  if (input.files && input.files[0]) {
    const reader = new FileReader();
    let fileName = input.files[0].name;
    reader.onload = () =>
      $('input[name="value"]').val(
        fileName
          .split(".")
          .slice(0, -1)
          .join(".")
      );
  }
};

const setValues = (response, id) => {
  const names = ["code", "price", "wait", "discount"];

  for (let i = 0; i < names.length; i++) {
    $(`input[name=${names[i]}]`).val(response[names[i]]);
  }
  $('#wait > option[selected="selected"]').removeAttr("selected");
  if (!response.wait)
    $('#wait > option[value="none"]').attr("selected", "selected");
  else
    $(`#wait > option[value="${response.wait}"]`).attr("selected", "selected");

  $("#modal-form").attr("action", "pricetable/" + id);
  // refresh the selectric select to update default value
  select.selectric("refresh");
};

const showColorList = id => $("#color-list" + id).show();
const hideColorList = id => $("#color-list" + id).hide();

// Remove image
$("[data-remove-image]").on("click", e => {
  e.preventDefault();

  // Setup our selector
  const selector = "#" + $(e.currentTarget).data("remove-image");

  if (confirm("Weet u zeker dat u deze afbeelding wilt verwijderen?")) {
    $(selector).val("");
    $("form#update").submit();
  }
});

const getCrossSellProducts = () => {
  $.get(
    "cross-sells/search",
    {
      query: $("#cross-sells-input").val()
    },
    response => {
      $(".results").empty();
      response.forEach(result => {
        $(
          `<div class="result"><input type="checkbox" name="cross-sells[${
            result.id
          }]"/> ${result.name}</div>`
        ).appendTo(".results");
      });
    }
  );
};

$("#cross-sells-button").on("click", e => {
  getCrossSellProducts();
});

$("#cross-sells-input").on("keydown", e => {
  if (e.keyCode === 13) {
    getCrossSellProducts();
  }
});

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})
